import PropTypes from "prop-types";

/* Definition-list card. Rows with no value drop out entirely. */
export const InfoRow = ({ label, value }) =>
  value === null || value === undefined || value === "" ? null : (
    <div className="c4rtn__row">
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

const InfoPanel = ({ title, children, footer }) => (
  <section className="c4rtn__panel">
    <h3 className="c4rtn__panel-title">{title}</h3>
    <dl className="c4rtn__rows">{children}</dl>
    {footer ? <div className="c4rtn__panel-foot">{footer}</div> : null}
  </section>
);

InfoPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default InfoPanel;
